import React from 'react';

const GridItemSkeleton: React.FC = () => {
  return (
    <div className="w-full aspect-square rounded-[30px] bg-white dark:bg-darkCardBackground p-[8%] border border-gray-200 dark:border-gray-700 relative flex flex-col justify-start overflow-hidden">
      {/* Top Row Skeleton - Fixed height */}
      <div className="w-full flex flex-row items-start justify-between gap-1 mb-4 h-8">
        <div className="h-4 w-3/4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
        <div className="w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse flex-shrink-0" />
      </div>

      {/* Image Container Skeleton - Fixed height to maintain consistency */}
      <div className="flex flex-1 h-[calc(100%-2rem)] aspect-square pt-[15%] self-end relative items-end justify-end">
        <div className="w-4/5 h-4/5 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse" />
      </div>
    </div>
  );
};

export default GridItemSkeleton; 